import {
  IButtonStyles,
  mergeStyles,
} from "@fluentui/react/";

export const buttonS: Partial<IButtonStyles> = {
  root: {
    marginRight: "20px",
  },
};

export const container = mergeStyles({
  marginTop: "30px",
  display: "flex",
});
